import React, {Component} from 'react';
import moment from 'moment';
import swal from 'sweetalert';
import {translate} from 'react-i18next';
import Help from '../../generics/help';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ContentRemove from 'material-ui/svg-icons/content/remove';
import Inputmask from 'inputmask';
import RaisedButton from 'material-ui/RaisedButton';
import $ from 'jquery';

var Config = require('../../../config');

class PlasmaInactivar extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.generate = this.generate.bind(this);
		this.addUnit = this.addUnit.bind(this);
		this.searchComponent = this.searchComponent.bind(this);
		this.onSave = this.onSave.bind(this);
		this.saving = this.saving.bind(this);

		this.state = {
			date:"",
			hour:"",
			site:"",
			health_facilities:[],
			load_site:false,
			observations:"",
			amount:"",
			unit:"",
			units:[],
			indice:-1,
			requestSelected:[],
			width:"",
			process:'register',
			unit_removed:false,
			reasons:[],
			ids:[],
		}
	}

	componentDidMount(){
		$(document).on('blur', '#date', (e)=>{
			if(e.target.validationMessage !== ""){
				swal('Error', e.target.validationMessage, 'error');
				
				setTimeout(()=>{
					$('#'+e.target.id).val('')
						.attr('type', 'text')
						.attr('type', 'date');
				}, 4000);

				$('#'+e.target.id).addClass('error');
			}else{
				$('#'+e.target.id).removeClass('error');
			}
		});
		
		var selector = document.getElementById('hour');
		var im = new Inputmask("--:--");
		im.mask(selector);

		var w = document.getElementById('tbl_list').offsetWidth;
		this.setState({width: w / 8});

		fetch(Config.default.apiGateway.URL+'discard_reasons?option=discard_units',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			if(response !== undefined){
				this.setState({reasons:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date:date[2]+'-'+date[1]+'-'+date[0],
				hour:hours,
			});
		});

		fetch(Config.default.apiGateway.URL+'national_centers/exclude_hemored?health_facilities_id='+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			var temp = [];
			for (var i = 0; i < response.length; i++) {
				response[i].name = response[i].national_center.name +' - '+
													response[i].address.estado !== null	?
														response[i].address.estado
													: "";
				temp.push(response[i].national_center)
			};

			this.setState({national_centers: temp});

			if(this.props.match.params.id !== undefined){
				this.props.waiting.handleShow('Cargando...');
				fetch(Config.default.apiGateway.URL+'plasma_process/'+this.props.match.params.id,{
					method: 'GET',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
					
						var index = this.state.national_centers.findIndex(obj =>
							obj.id === response.plasma_process.national_centers_id
						);

						this.setState({
							date:moment(response.plasma_process.date).format('YYYY-MM-DD'),
							hour:moment(response.plasma_process.hour).format('HH:mm'),
							site:response.plasma_process.national_centers_id,
							observations: response.plasma_process.observations,
							amount:response.plasma_parts.length,
							process:'update',

						});

						setTimeout(()=>{
							var obj = [];
							var fields = [];

							for(var i = 0; i < parseInt(response.plasma_parts.length); i++){
								obj.push({
									index:i+1, 
									unit:response.plasma_parts[i].unit_number, 
									id:response.plasma_parts[i].unit_id,
									id_part: response.plasma_parts[i].id
								});
							}

							var aux = [];
							var cont = 0
							obj.map((a, i)=>{
								if(fields[cont] === undefined){
									fields.push([a]);
								}else{
									if(fields[cont].length < 8){
										fields[cont].push(a);
									}else{
										cont++;
										fields.push([a]);
									}
								}	
							});

							fields.map((f, i)=>{
								if(f.length < 8){
									for(var j = f.length; j < 8; j++){
										fields[i].push({index:j, unit:'empty', id:"empty"});
									}
								}
							})

							this.setState({units:fields, indice:0,requestSelected:[this.state.national_centers[index]]});

						}, 500);


					}
				})
			}
		});	
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleTypeAheadChange = name => values =>{
		if(values.length > 0){
    		this.setState({
	            site: values[0].id
	        });

	        if (name === 'site') {
	        	this.setState({
					indice:0,
					requestSelected:values,
			    });
	        };
        }
	}

	autocompleteSite = (query) => {
	    this.setState({
			indice:-1,
			requestSelected:[],
	    });
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	generate(){
		if(this.state.amount !== ""){
			var fields = [];
			var obj = [];

			for(var i = 1; i <= parseInt(this.state.amount); i++){
				obj.push({index:i, unit:"", id:""});
			}

			var aux = [];
			var cont = 0
			obj.map((a, i)=>{
				if(fields[cont] === undefined){
					fields.push([a]);
				}else{
					if(fields[cont].length < 8){
						fields[cont].push(a);
					}else{
						cont++;
						fields.push([a]);
					}
				}	
			});

			fields.map((f, i)=>{
				if(f.length < 8){
					for(var j = f.length; j < 8; j++){
						fields[i].push({index:j, unit:'empty', id:"empty"});
					}
				}
			})


			this.setState({units:fields});
		}else{
			swal('Error', 'Debe ingresar una cantidad valida', 'error');
		}			
	}

	addUnit(e){
		if(e.key === 'Enter'){
			var unit_number = this.state.unit;
			
			if(this.state.units.length > 0){
				if(unit_number !== ""){
					e.target.value = unit_number
					e.key = 'Enter';

					var find = true;
					this.state.units.map((unit)=>{
						unit.map((u)=>{
							if(u.unit === unit_number){
								find = false;
							}
						})
					})

					if(find){
						this.searchComponent(e);	
					}else{
						swal('Error', 'El numero de unidad ya se ha sido ingresado', 'error');
					}
					
				}else{
					swal('Error', 'Debe ingresar un número de unidad', 'error');
				}
			}else{
				swal('Error', 'Debe igresar una cantidad', 'error');
			}
		}
			
	}

	removeUnit(e){
		if(e.key === 'Enter'){
			var units = this.state.units;
			var unit_number = this.state.unit;

			if(unit_number !== ""){
				var cont = 0;
				var ids = this.state.ids;

				units.map((unit, i)=>{
					
					unit.some((u, x)=>{

						if(u.unit === unit_number){
							ids.push(u.id);

							unit.splice(x, 1);
								
							cont++;
						}
					});

					if(unit.length < 8){
						for(var j = unit.length; j < 8; j++){
							units[i].push({index:j, unit:'empty', id:"empty"});
						}
					}
					
				});

				if(cont === 0){
					swal('Error', 'Número de unidad no existente en el listado', 'error');
				}else{
					this.setState({units: units, unit:"", unit_removed:true, ids:ids});
				}

			}else{
				swal('Error', 'Debe ingresar un número de unidad', 'error');
			}

		}
	}

	searchComponent(e){
		if(e.key === 'Enter'){
			e.preventDefault();	
		
			fetch(Config.default.apiGateway.URL+'units/send_unit?health_facilities_id='+
				sessionStorage.getItem('health_facilities_id')+'&unit_number='+e.target.value, {
				method: 'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(res.ok){
					return res.json();
				}else{
					res.text().then(msg=>{
						swal("Error", msg, 'error')
					});
				}
			})
			.then(response=>{
				if(response !== undefined){
					var units = this.state.units;

					var index = response.findIndex(obj => obj.blood_component.component_type === 'PLASMA');

					if(index !== -1){
						units.some((unit)=>{
							unit.some((u)=>{	
								if(this.state.unit !== ""){
									if(u.unit === ""){
										u.unit = response[index].unit.unit_number;
										u.id = response[index].unit.id;
										this.setState({unit:""});
										return false;
									}
								}
									
							});
						});
					
					}else{
						swal(
							'Error', 
							'El numero de unidad esta relacionado a un componente distinto de plasma', 
							'error'
						);
					}
					
				}
			});
		}
	}

	saving(apiUrl, method, obj){
		this.props.waiting.handleShow('Guardando...');
		fetch(Config.default.apiGateway.URL+apiUrl, {
			method:method,
			body:JSON.stringify(obj),
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(result){
					swal('Error', result, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					date:"",
					hour:"",
					site:"",
					load_site:false,
					observations:"",
					amount:"",
					unit:"",
					units:[],
					indice:-1,
					requestSelected:[],
				})	
				this.props.history.goBack();	
			}
		});
	}

	onSave(e){
		e.preventDefault();
		var error = '';
		var method = 'POST';
		var apiUrl =  'plasma_process';

		if(this.state.units.length === 0){
			error = 'Debe ingresar una cantidad';
		}

		if(this.state.site === ""){
			error = 'No se ha seleccionado sitio de envío';
		}

		var obj = {
			date:this.state.date,
			hour:this.state.hour,
			health_facilities_id:sessionStorage.getItem('health_facilities_id'),
			national_centers_id:this.state.site,
			observations:this.state.observations,
			plasma_parts: [],
		}

		var units = this.state.units
		units.map((unit)=>{
			unit.map((u)=>{
				if(u.id !== 'empty' && u.id !== ""){
					if(this.state.process === 'register'){
						obj.plasma_parts.push({unit_id:u.id});		
					}else{
						obj.plasma_parts.push({unit_id:u.id, plasma_process_id:this.props.match.params.id});	
					}
					
				}
			});
		});


		if(this.state.process !== 'register'){
			obj.id = this.props.match.params.id;
			obj.discard_unit_ids = this.state.ids;

			method = 'PUT';
			apiUrl = 'plasma_process/'+obj.id;	
		}


		if(error === ''){
			if(this.state.process !== 'register'){
				if(this.state.ids.length > 0){
					var msg = '<div class="col-xs-12">'+
								'<div class="col-xs-12">'+
									'<h4>Las unidades retiradas serán dadas de baja</h4>'+
								'</div>'+
								'<div class="col-xs-12">'+
									'<span class="span-min">Motivo de baja</span>'+
									'<select name="reason_id" id="reason_id" class="form-control" '+
										'style="height:30px">'+
										'<option value="">Seleccione...</option>'+
										this.state.reasons.map((r)=>(
											'<option value="'+r.id+'">'+
												r.name+
											'</option>'
										))+
										
									'</select>'+
								'</div>'+
							'</div>';
					swal({
				        title: '¿Está seguro?',
				        text: msg,
		        		html: true,
				        showCancelButton: true,
				        confirmButtonColor: '#DD6B55',
				        confirmButtonText: 'Confirmar!',
				        cancelButtonText: '¡Cancelar!',
				        closeOnConfirm: false,
				        closeOnCancel: true
				    },  (isConfirm)=> {
				    	if(isConfirm){
				   			obj.discard_reason_id = document.getElementById('reason_id').value;

				   			if(obj.discard_reason_id !== ""){
				   				swal.close();
				   				this.saving(apiUrl, method, obj);
				   			}else{
				   				swal('Error', 'Debe seleccionar un motivo de baja', 'error');
				   			}
				    	}
				    	
				    });
				}else{
					this.saving(apiUrl, method, obj);
				}	
			}else{
				this.saving(apiUrl, method, obj);
			}
				
		}else{
			swal('Error', error, 'error');
		}
	}

	render(){
		const {t} = this.props;
		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Productos Hemostáticos ->
						Plasma a Industrializar
					</h5>
				</div>
				{/*<Help 
					{...this.props}
	                menu={"help_plasmatic_prod"} 
	                submenu={"help_plasmatic_discard"}  />
				*/}
				<div className="col-xs-12">
					<div className="col-xs-12 col-sm-2">
						<span className="span-min">Fecha Envío</span>
						<input type="date" name="date" id="date" value={this.state.date}
							onChange={this.handleChange} className="form-control hour-input" />
					</div>
					<div className="col-xs-12 col-sm-1">
						<span className="span-min">Hora Envío</span>
						<input name="hour" id="hour" type="text"
							data-inputmask-alias="datetime"  data-inputmask-inputformat="HH:MM"  
							data-inputmask-placeholder="-" className="form-control"
							value={this.state.hour || ""}  onChange={this.handleChange} />
					</div>
					<div className="col-xs-12 col-sm-4">
						<span className="span-min">Sitio Envío</span>
						<AsyncTypeahead
				          	labelKey={(option) => `${option.name}`}
				          	minLength={0}
				          	inputProps={{
				          		name:"site",
				          		required: true,
				          		id:"site"
				          	}}
				          	id="AutSite"
				          	options={this.state.national_centers}
				          	onChange={this.handleTypeAheadChange('site')}
				            onSearch={this.autocompleteSite}
				          	defaultSelected={this.state.health_facilities.slice(this.state.indice, 1)}
				          	selected={this.state.requestSelected}
				          	ref={ref => this._typeahead = ref}
				          	useCache={false}
				          	isLoading={this.state.load_site}
				          	delay={700}
				          	paginationText="Mostrar mas resultados..."
				        />
					</div>
				</div>
				<div className="col-xs-12">
					<div className="col-xs-12 col-sm-4">
						<span className="span-min">Observaciones</span>
						<textarea name="observations" id="observations" value={this.state.observations}
							onChange={this.handleChange} className="form-control"
							style={{height:"80px",width:"100%",resize:"none"}}>
						</textarea>
					</div>
					{this.state.process === 'register' ?
						<div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Cantidad de Plasmas</span>
								<input type="number" name="amount" id="amount" value={this.state.amount}
									onChange={this.handleChange} className="form-control hour-input" />
							</div>
							<div className="col-xs-12 col-sm-1">
								<FloatingActionButton className="action-btn" mini={true} style={{marginTop: 17 }} 
									onClick={this.generate} iconStyle={{height: 25, width: 25}}>
			                      	<ContentAdd/>
			                    </FloatingActionButton>
							</div>
						</div>
					:null}
						
				</div>

				<hr style={{width:'90%'}} />

				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2">
						<span className="span-min">No. Unidad</span>
						<input type="number" name="unit" id="unit" value={this.state.unit} 
							onChange={this.handleChange} className="form-control hour-input" 
							onKeyPress={(e) => this.state.process === 'register' ? this.addUnit(e) : this.removeUnit(e)}
						/>
					</div>
					<div className="col-xs-12 col-sm-1">
						<FloatingActionButton className="action-btn" mini={true} style={{marginTop: 18 }} 
							onClick={(e)=>{e.key = 'Enter'; 
								return this.state.process === 'register' ?
									this.addUnit(e)
								: this.removeUnit(e)
							}} 
							iconStyle={{height: 25, width: 25}}>
							{this.state.process === 'register' ? 
	                      		<ContentAdd/>
	                      	: <ContentRemove />}
	                    </FloatingActionButton>
					</div>
				</div>
				<div className="col-xs-12">
					<table className="table" id="tbl_list" style={{width:(parseInt(this.state.width) * 8)+'px'}}>
						<tbody>
							{this.state.units.map((unit, j)=>(
								<tr key={j}>
									{unit.map((u, i)=>(
										u.unit !== 'empty' ?
											<td key={i} style={{width:this.state.width+'px'}}>
												<input className="form-control" id={i} value={u.unit} disabled />
											</td>
										: <td key={i} style={{width:this.state.width+'px'}}>
											
										</td>

									))}
								</tr>
							))}
						</tbody>
					</table>
				</div>

				<div className="col-xs-12" style={{textAlign:'center'}}>
					<RaisedButton className="action-btn" 
						label={this.state.process === 'register' ? t('content.generics.buttons.save') : t('content.generics.buttons.confirm')} 
						primary={true} 
			        	onClick={this.onSave}  style={{margin:12}}/>
	        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} 
	        			onClick={(e)=>this.props.history.goBack()}/>
				</div>

	        </div>
		)
	}
}

export default translate('translations')(PlasmaInactivar);